import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ComposeFeedback" */ './lazyIndex')
);

export const ComposeFeedback = createLazyComponent(lazyModule, m => m.ComposeFeedback);
export { default as ComposeFeedbackViewState } from './store/schema/ComposeFeedbackViewState';
export { default as createComposeFeedbackViewState } from './utils/createComposeFeedbackViewState';
export const lazyShowFeedbackRibbon = new LazyAction(lazyModule, m => m.showFeedbackRibbon);
